import { Flex } from "antd";
import React from "react";
import { format } from "date-fns";

const DateSelector = ({ selectedDate, onDateChange }) => {
  const handleDateChange = (e) => {
    const value = e.target.value;
    if (value) {
      onDateChange(value);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <p style={{ fontSize: "16px", fontWeight: "bold" }}>Choose Date </p>
      <input
        style={{ cursor: "pointer", width: "auto" }}
        type="date"
        value={selectedDate ? format(new Date(`${selectedDate}T00:00:00`), "yyyy-MM-dd") : ""}
        onChange={handleDateChange}
        className="form-control mb-3"
      />
    </div>
  );
};

export default DateSelector;
